document.addEventListener('DOMContentLoaded', function () {
  var form = document.querySelector('form[action="/cart/add"]');
  if (!form) return;

  var productEl = document.getElementById('ProductJson-product-template')
    || document.querySelector('script[data-product-json]')
    || document.querySelector('[data-product-json]');
  if (!productEl) return;

  var product;
  try { product = JSON.parse(productEl.textContent); } catch(e) { return; }
  if (!product.options || product.options.length < 2) return;

  var allInputGroups = form.querySelectorAll('.product-form__input');
  if (allInputGroups.length < 2) return;

  var group2 = allInputGroups[1];
  group2.style.display = 'none';

  var getValidOption2 = function(opt1Val) {
    return product.variants
      .filter(function(v) { return v.option1 === opt1Val; })
      .map(function(v) { return v.option2; });
  };

  form.addEventListener('change', function() {
    var checked1 = allInputGroups[0].querySelector('input:checked');
    if (!checked1) return;
    var val1 = checked1.value;
    var valid2 = getValidOption2(val1);

    var labels2 = group2.querySelectorAll('label');
    labels2.forEach(function(label) {
      var input = label.querySelector('input');
      if (!input) return;
      label.style.display = valid2.indexOf(input.value) > -1 ? '' : 'none';
    });

    group2.style.display = '';

    var checked2 = group2.querySelector('input:checked');
    if (checked2 && valid2.indexOf(checked2.value) === -1) {
      checked2.checked = false;
    }
  });
});